import type { ReactNode } from "react";
import { useProject } from "./hooks";
import { useCurrentUser } from "@/features/auth/hooks";
import { holds } from "@/features/auth/permissions";

export function ProjectAction({ permission, children }: { permission: string; children: ReactNode }) {
  return useProject().can(permission) ? children : null;
}

export function GlobalAction({ permission, children }: { permission: string; children: ReactNode }) {
  const user = useCurrentUser().data;
  return holds(user?.permissions ?? [], permission) ? children : null;
}
